document.addEventListener("DOMContentLoaded", () => {
  let refreshTimer = null;

  function debounceRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshAll, 80);
  }

  function getOptionPosition(input) {
    const id = input.id || "";
    const match = id.match(/__main-(\d+)-/);
    if (match) return parseInt(match[1], 10);

    const rawName = input.getAttribute("name") || "";
    const name = rawName.replace(/\s+/g, "");
    const matchName = name.match(/-(\d+)$/);
    if (matchName) return parseInt(matchName[1], 10);

    return null;
  }

  function findLabel(input) {
    if (input.id) {
      const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (label) return label;
    }
    if (input.nextElementSibling && input.nextElementSibling.tagName === "LABEL") return input.nextElementSibling;
    if (input.previousElementSibling && input.previousElementSibling.tagName === "LABEL") return input.previousElementSibling;
    return input.closest("label") || null;
  }

  function isUnavailable(input) {
    return (
      input.disabled ||
      input.classList.contains("disabled") ||
      input.classList.contains("is-disabled") ||
      input.getAttribute("aria-disabled") === "true"
    );
  }

  function refreshOneGroup(sizeInputs) {
    // 1) Hide/show
    sizeInputs.forEach((input) => {
      const label = findLabel(input);
      if (!label) return;
      const wrapper = label.closest("li") || label;
      wrapper.style.display = isUnavailable(input) ? "none" : "";
    });

    // 2) Auto-select: se la taglia selezionata è ora non disponibile (dopo cambio colore),
    // seleziona la prima disponibile.
    const checked = sizeInputs.find((i) => i.checked);
    const checkedBad = checked ? isUnavailable(checked) : true;

    if (checkedBad) {
      const firstAvailable = sizeInputs.find((i) => !isUnavailable(i));
      if (firstAvailable && !firstAvailable.checked) {
        firstAvailable.click();
      }
    }
  }

  function refreshAll() {
    const radios = Array.from(document.querySelectorAll('input[type="radio"][data-option-value-id]'));
    const sizeInputsAll = radios.filter((input) => getOptionPosition(input) === 2);

    // Raggruppa per attributo form (Rise spesso collega così gli input al product form)
    const groups = new Map();
    sizeInputsAll.forEach((input) => {
      const formId = (input.getAttribute("form") || "no-form").trim();
      if (!groups.has(formId)) groups.set(formId, []);
      groups.get(formId).push(input);
    });

    groups.forEach((inputs) => refreshOneGroup(inputs));
  }

  refreshAll();
  document.addEventListener("change", debounceRefresh, true);
  document.addEventListener("click", debounceRefresh, true);
});